<div class="expansion-panel {{theme}}" [ngClass]="{'expansion-panel--opened': isOpened}">
  <input type="checkbox" id="box-{{ id }}" [checked]='isOpened'>
  <div class="expansion-panel__container">
    <label for="box-{{ id }}" (click)="isOpened = !isOpened">
      <div class="expansion-panel__title" [ngStyle]="titleStyles">{{ title }}</div>
      <div class="expansion-panel__button">
        @if (theme === 'default') {
          <img
            src="assets/images/dashboard/insights/down-arrow.svg"
            [@turnOver]="isOpened ? 'turned': 'level'"
            alt=""
            >
        } @else {
          <img
            [@turnOver]="isOpened ? 'turned': 'level'"
            src="assets/images/dashboard/insights/down-arrow_blue.svg"
            alt=""
            >
        }
      </div>
      <ng-container *ngTemplateOutlet="titleContent"></ng-container>
    </label>

    @if (isOpened) {
      <div class="expansion-panel__content" @rollIn>
        <div class="expansion-panel__content-wrap">
          <ng-content></ng-content>
        </div>
      </div>
    }
  </div>
</div>
